// extracted by mini-css-extract-plugin
export var banner = "_hj-0";
export var closeButton = "_hj-2";
export var greenCheckmark = "_hj-3";
export var hereLink = "_hj-4";
export var titleIcon = "_hj-1";